import Vue from 'vue'
import Router from 'vue-router'
//  import HelloWorld from '@/components/HelloWorld'
import StartView from '@/components/StartView'
import QuizView from '@/components/QuizView'
import LastView from '@/components/LastView'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'StartView',
      component: StartView
    },
    {
      path: '/quiz',
      name: 'QuizView',
      component: QuizView
    },
    {
      path: '/done',
      name: 'LastView',
      component: LastView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js